<template>
  <modal class="agreement-modal">
    <h2 slot="header" class="title">
      <br/>important announcement</h2>

    <div slot="body" class="body">
      <p>to optimize delivery we highly recommend sending MMS notification images to all carriers.
        If you are sending to Verizon we <strong>strongly</strong> recommend sending a MMS notification image.
        utilize the configuration shown below in order to add an MMS to your campaign.
        If you have a custom image or logo you would like added to the platform please contact your CSM today
      </p>

      <img :src="notificationImage" alt="announcement-image" class="w-2/3 m-4 h-auto" >
    </div>

    <div slot="action"
         class="button modal-click-action justify-center" data-cy='agreement-modal-button'
         @click="$emit('rejectAgreementModal', agreementCheck)">
      get started
    </div>

    <div slot="footer" class="modal-footer">
      <label>
        <input type="checkbox" v-model="agreementCheck">
        do not show this message again
      </label>
    </div>
  </modal>
</template>

<script>
import Modal from "../shared/Modal.vue";
import notificationImage from "stashboard/notification-image.png"

export default {
  name: "AgreementModal",

  components: { Modal },

  data() {
    return {
      agreementCheck: false,
      notificationImage
    }
  }
}
</script>

<style lang="scss" scoped>
.agreement-modal{
  ::v-deep .modal{
    padding: 1em 2em 0 3em;
    border: 0;
    width: 100%;
    text-align: center;

    h2{
      font-family: 'AileronThin';
      font-size: 1.7rem;
    }
    .button{
      margin-top: 36px;
      border-radius: 14px;
      font-size: 26px;
      font-weight: bold;
      padding: 15px 58px;
    }
    .modal-footer{
      margin-top: 40px;
      text-align: left;
    }

    p {
      margin-top: 20px;
      font-size: normal;
    }

    @media only screen and (min-width: 1023px) {
      ::v-deep .modal {
        padding: 1rem .5rem 0 .5rem;
        border-radius: 10px;
        border: 1px solid #128ff9;
        width: 450px;

        h2 {
          font-size: 1rem;
        }

        .button {
          font-size: .8rem;
          border-radius: 10px;
          padding: 10px 50px;
          margin-top: 1rem;
        }

        .modal-footer {
          margin-top: 1rem;
          label {
            font-size: 0.8rem;
          }
        }
      }
    }
  }
}
</style>